export default __webpack_public_path__ + "static/media/upcoming_back.dfb6ee8c.svg";